import { store } from '@core/Store'
import { startListening } from '@core/Store/listenerMiddleware'
import { FeatureFlagKeyName, FeatureValueType } from '@mobi/settings/featureFlags'
import { isAnyOf } from '@reduxjs/toolkit'
import { setFeatures, mergeFeatures } from '../Store'
import { getFeatures } from '../Store/selectors'
import { _returnFeatureValueOrDefault } from './returnFeatureValueOrDefault'

/**
 * Listen to any changes to this feature flag
 * @param flag
 * @param listener
 * @returns a dispose function
 */
export function subscribeToFeatureChanges<K extends FeatureFlagKeyName>(
  flag: K,
  listener: (val: FeatureValueType<K>) => void
): () => void {
  let lastVal: FeatureValueType<K> | undefined = undefined
  const handler = () => {
    const features = getFeatures(store.getState())
    const thisVal = _returnFeatureValueOrDefault(features[flag], flag) as FeatureValueType<K>
    if (lastVal === undefined || thisVal !== lastVal) {
      lastVal = thisVal
      listener(thisVal)
    }
  }
  handler()
  const dispose = startListening({
    matcher: isAnyOf(setFeatures, mergeFeatures),
    effect: handler,
  })
  return dispose
}
